// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"279":"d6382be8b107d6e291ce","415":"a125d409741b49908081","454":"43ebe77994f8786324b6"}[chunkId] + ".js";
};